// extracted by mini-css-extract-plugin
export default {"main":"styles_main__MW4QU","image":"styles_image__aXOEG","text":"styles_text__lPgxO","button":"styles_button__CLaUA"};